import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import CTASection from "./components/CTASection";
import SEOContent from "./components/SEOContent";
import Testimonials from "./components/Testimonials";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <CTASection />
        <SEOContent />
        <Testimonials />
      </main>
      <Footer />
    </>
  );
}